import type { SortOrder } from 'antd/es/table/interface';

import type { TRuleWithTheme } from '@/styles/theme';

export const sortIcon: TRuleWithTheme<{ sortOrder?: SortOrder }> = ({ theme, sortOrder }) => ({
    color: 'transparent',

    transform: 'rotate(180deg)',
    width: '1rem',
    height: '1rem',

    ...(sortOrder === 'descend' && { transform: 'rotate(0deg)', color: theme.colors.iconsTertiary }),
    ...(sortOrder === 'ascend' && { transform: 'rotate(180deg)', color: theme.colors.iconsTertiary }),
});
